import { Capacitor } from "@capacitor/core";
import React from "react";
import { AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { MdArrowForwardIos } from "react-icons/md";
import { Link } from "react-router-dom";
import { AppName, footerString } from "../../../Strings/Strings";
import "../../css/Footer.css";

function Footer() {
  return (
    <div>
      <footer id="footer">
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-6 footer-contact">
                <div className="d-flex">
                  <div className="text-center">
                    {/* only on web */}
                    {!Capacitor.isNativePlatform() && (
                      <img src="logo512.png" alt="" width={100} />
                    )}
                    <div className="text-start">
                      <h3>{footerString.AppName}</h3>
                      {footerString.contact.map((data, index) => {
                        return (
                          <p key={index}>
                            <strong>{data.label}:</strong> {data.value}
                            <br />
                          </p>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>

              {footerString.links.map((L, index) => {
                return (
                  <div className="col-lg-3 col-md-6 footer-links" key={index}>
                    <h4>{L.label}</h4>
                    <ul>
                      {L.data.map((D, i) => {
                        return (
                          <li key={i}>
                            <i>{<MdArrowForwardIos />}</i>{" "}
                            <Link to={D.path}>{D.name}</Link>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="container text-gray d-md-flex py-4">
          <div className="me-md-auto text-center text-md-start">
            <div className="copyright">
              &copy; Copyright{" "}
              <strong>
                <span>
                  {" "}
                  <Link to="/testimonials" className="text-white">
                    {AppName}.
                  </Link>{" "}
                </span>
              </strong>
              All Rights Reserved
            </div>
            <div className="credits text-gray">
              Designed by{" "}
              <a
                href="https://github.com/sangamprashant"
                target="_blank"
                rel="noreferrer"
                className="text-black"
              >
                Prashant srivastav
              </a>
            </div>
          </div>
          <div className="social-links text-center text-md-right pt-3 pt-md-0">
            <a
              href="https://instagram.com/sangam_prashant"
              aria-label={`Go to prashant instagram`}
            >
              <i>{<AiFillInstagram />}</i>
            </a>
            <a
              href="https://www.linkedin.com/in/sangamprashantsrivastav"
              aria-label={`Go to prashant linkedinpage`}
            >
              <i>{<FaLinkedinIn />}</i>
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
